<template>
  <Default>
    <div class="col-md-10 ms-auto me-auto">
<!--      <div class="mb-3">-->
<!--        <router-link to="/order" class="h5 text-decoration-none">-->
<!--          <i class="bi bi-arrow-bar-left"></i>zpět-->
<!--        </router-link>-->
<!--      </div>-->
      <h1>Historie Objednávek</h1>

      <table class="table">
        <thead>
        <tr>
          <th>#</th>
          <th>Vytvořeno</th>
          <th>Požadované datum doručení</th>
          <th>Poznámka</th>
          <th v-if="hasPrices" class="text-end">Cena bez DPH</th>
          <th>Stav</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="orders" v-for="order of orders" class="tr-link"
            @click="$router.push({name:'order-detail',params:{orderId: order.id}})">
          <td>
            {{ order.counterNumber }}
            <small v-if="order.custom?.orderType === 'supplement'" class="d-block text-muted">
              dodatečná k č. {{ order.custom.parentOrderNumber }}
            </small>
          </td>
          <td>{{ appStore.formatDateTime(order.createdAt) }}</td>
          <td>{{ order.custom.deliveryDate ? appStore.formatDate(order.custom.deliveryDate) : '–' }}</td>
          <td>{{ order.custom.note || '–' }}</td>
          <td v-if="hasPrices" class="text-end text-nowrap">
            {{ typeof order.custom?.customerTotal === 'number' ? formatCzk(order.custom.customerTotal) : '–' }}
          </td>
          <td>
            <span :class="['badge', 'rounded-pill', 'px-3', 'py-1', statusClass(order.status)]">
              {{ statusLabel(order.status) }}
            </span>
          </td>
          <td class="text-end">
            <router-link :to="{name:'order-detail', params:{orderId: order.id}}" class="btn btn-sm btn-outline-primary">
              <i class="bi bi-eye me-1"></i>Detail
            </router-link>
          </td>
        </tr>
        <tr v-else>
          <td colspan="8" class="text-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between">
          <span class="mt-2 bg-light rounded px-2 py-1">
            stránek: {{ totalPages }}
          </span>

        <nav aria-label="Page navigation example" v-if="totalPages > 0">
          <ul class="pagination">
            <li class="page-item">
              <button class="page-link" @click="goToPage(1)" :disabled="page === 1">První</button>
            </li>
            <li class="page-item">
              <button class="page-link" @click="goToPage(--page)" :disabled="page === 1">Předchozí</button>
            </li>
            <li class="page-item">
              <button class="page-link">{{ page }}</button>
            </li>
            <li class="page-item">
              <button class="page-link" @click="goToPage(++page)" :disabled="page === totalPages">Další</button>
            </li>
            <li class="page-item">
              <button class="page-link" @click="goToPage(totalPages)" :disabled="page === totalPages">Poslední</button>
            </li>
          </ul>
        </nav>
        <p v-else class="fw-bold">Nebyly nalezeny žádné objednávky!</p>


        <div class="d-flex align-items-start gap-2">
          <button type="button" class="btn btn-outline-secondary" @click="findOrders">
            <i class="bi bi-arrow-clockwise me-1"></i>Obnovit
          </button>
          <div class="dropdown">
            <button class="btn btn-light dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ limit }}
            </button>
            <ul class="dropdown-menu">
              <li v-for="_limit of paginationLimits">
                <button class="dropdown-item" @click="changeLimit(_limit)">
                  {{ _limit }}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </Default>
</template>
<script lang="ts">

import Default from "@/layouts/default.vue";
import {useAppStore} from "@/stores/appStore";
import {ResponseEntityOrder} from "@haxo-cz/orders-ts-client";
import {formatCzk} from "@/components/gira/orderRows";

export default {
  name: "OrderHistoryView",
  components: {Default},
  data() {
    return {
      appStore: useAppStore(),
      page: 1,
      limit: 10,
      paginationLimits: [5, 10, 20, 50, 100],
      totalOrdersCount: 0,
      totalPages: 0,
      orders: null as null | Array<ResponseEntityOrder>
    }
  },
  computed: {
    hasPrices(): boolean {
      return (this.orders ?? []).some(order => typeof order.custom?.customerTotal === 'number');
    },
  },
  methods: {
    formatCzk,
    statusLabel(status: string): string {
      switch (status) {
        case 'created':   return 'Čeká na přijetí';
        case 'completed': return 'Přijato do systému';
        case 'error':     return 'Chyba při předání';
        case 'cancelled': return 'Zrušeno';
        default:          return status;
      }
    },
    statusClass(status: string): string {
      switch (status) {
        case 'created':   return 'bg-warning text-dark';
        case 'completed': return 'bg-success text-white';
        case 'error':     return 'bg-danger text-white';
        case 'cancelled': return 'bg-secondary text-white';
        default:          return 'bg-light text-dark';
      }
    },
    findOrders() {
      if (this.appStore.selectedProject) {
        this.orders = null;
        this.$ordersApi.findAllOrders(
            this.appStore.selectedProject.spaceId,
            this.appStore.selectedProject._id,
            this.page,
            this.limit,
            undefined,
            undefined,
            undefined,
            JSON.stringify({userId: this.appStore.mongoUser._id}),

        ).then((response) => {
          this.orders = response.data.data;
          this.totalOrdersCount = response.data.meta.totalCount;
          this.totalPages = response.data.meta.pagination.pages
        }).catch(e => {
          console.error("Chyba při načítání objednávek:", e);
        })
      }

    },
    goToPage(page: number) {
      this.page = page;
      console.log("finding Orders for page", page)
      this.findOrders();
    },
    changeLimit(_limit: number) {
      this.limit = _limit;
      this.findOrders();
    }
  },
  mounted() {
    this.findOrders();
  }
}
</script>
